import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, track } from "@/lib/api";
import { toast } from "sonner";
import { getSupportStatus } from "@/lib/hours";

const SettingsContext = createContext(null);
export const useSettings = () => useContext(SettingsContext);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    whatsapp_number: "5521973193851",
    whatsapp_message: "Olá! 👋 Preciso de ajuda com o Club Infinity.",
  });

  const refresh = useCallback(() => api.get("/settings").then((r) => setSettings(r.data)).catch(() => {}), []);
  useEffect(() => { refresh(); }, [refresh]);

  const openWhatsApp = useCallback((source = "generic", customMsg) => {
    track("whatsapp_click", source);
    const msg = encodeURIComponent(customMsg || settings.whatsapp_message);
    window.open(`https://wa.me/${settings.whatsapp_number}?text=${msg}`, "_blank");
    if (!getSupportStatus(settings).online) toast.info("Estamos fora do horário. Deixe sua mensagem e respondemos assim que voltarmos!");
  }, [settings]);

  const value = useMemo(() => ({ settings, setSettings, refresh, openWhatsApp }), [settings, refresh, openWhatsApp]);
  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
}
